import { isDateWithinValidityPeriod } from '@fora-monorepo/date-utils';
import { ValidationResult, ValidationRule } from '@foradevelopment/fora-ui';

export const isParameterDateWithinValidityPeriod =
  (errorMessage: string, fokParameterValidity: { validFrom: string; validTo: string | null }): ValidationRule =>
  (value: string): ValidationResult => {
    const isValid = isDateWithinValidityPeriod(value, fokParameterValidity);
    return { error: !isValid, errorMessage };
  };
